export const subscriptionRazorpayMutation = `mutation subscriptionRazorpay($site: String!, $input: CreateAccountAndSubscriptionMetadata!) {
  createAccountAndSubscription(site: $site, req: $input) {
    subscription {
      subscriptionStatus
    }
  }
}`

export const upgradeSubscriptionRazorpay = `mutation upgradeSubscriptionRazorpay($site: String!, $input: UpgradeSubscriptionMetadata!) {
    upgradeSubscription(site: $site, req: $input) {
      success
    }
}`
export const cancelSubscriptionRazorpay = `mutation cancelSubscriptionRazorpay($site: String!, $input: CancelSubscriptionMetadata
!) {
  cancelSubscription(site: $site, req: $input) {
    success
  }
}`

export const revertSubscriptionRazorpay = `mutation revertSubscriptionRazorpay($site: String!, $input: RevertSubscriptionMetadata
!) {
  revertSubscription(site: $site, req: $input) {
   success
  }
}`

